import { ValidationResult } from '../formField/types/form-validator';

export const WhitelistValidator = <T>(whitelist: T[], errorMessage: string) => {
  return async (value: T): Promise<ValidationResult> => {
    if (typeof value === 'string' && value === '') {
      return { valid: true };
    }

    if (value === null || value === undefined) {
      return { valid: true };
    }

    if (!whitelist.includes(value)) {
      return {
        valid: false,
        error: errorMessage,
      };
    }

    return { valid: true };
  };
};
